/*
=========================================================
* Vuetify Soft UI Dashboard PRO - v1.0.0
=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./state/store";
import DashboardPlugin from "./plugins/dashboard-plugin";

// common mixin, common state/store and common api
import mainMx from '@/mixins/mainMixin.js'
Vue.mixin(mainMx)

// Cognito auth: send the signed-in user's ID token to our API Gateway
import { installAuthInterceptor } from '@/auth/axiosAuth'
installAuthInterceptor()

import '@/scss/transitions.scss';

Vue.config.productionTip = false;
Vue.prototype.$env = process.env.VUE_APP_ENV

// Photoswipe Gallery
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);

// SweetAlert2
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

// plugin setup
Vue.use(DashboardPlugin);

new Vue({
  router,
  vuetify,
  store,
  watch: {
    '$route': function(to, from) {
      this.consoleLog('info', 'page/route changed: [from, to]', [from, to])
      this.consoleLog('state', 'clientIpAddress: ', this.mainStateGet('clientIpAddress'))
    },
  },
  render: (h) => h(App),
}).$mount("#app");
